export class CmpUserPhoneObject {
  id = 0;
  optedIn = true;
  phone = '';
  phoneTypeId = 0;
  phoneTypeName = '';
  primary = true;
  userId = 0;
  extension = '';
}
export class CmpUserEmailObject {
    id = 0;
    optedIn = true;
    email = '';
    primary = true;
    userId = 0;
}

export class CmpCreatedByUserObject {
  id: number | string = 0;
  firstName = '';
  lastName = '';
  email: string | null = null;
}
export class CmpUserConsumerProfileObject {
  gender = '';
  dob: string | null = '';
  adult: boolean | null = null;
  grade: number | null = null;
  graduationYear = '';
  imageUrl: string | null = null;
  originalImage: string | null = null;
  salesforceAccountId = '';
  salesforceContactId = '';
  visibility = 1;
  visibilityExplanation = '';
  createdBy = new CmpCreatedByUserObject;
  updatedBy = new CmpCreatedByUserObject;
  nickName: string | null = '';
  salesforceRecordVersion: number | null = null;
  defaultConsumerType = '';
}

export class CmpFamilyMemberObject {
  id = 0;
  firstName = '';
  lastName = '';
  email = '';
  cellPhone = '';
  homePhone = '';
  optedIn = false;
  emailVerifiedAt: Date | null = null;
  type = '';
  relationship: string | null = null;
  familyId = 0;
  userConsumerProfile: { [index: string]: CmpUserConsumerProfileObject } = { '0': new CmpUserConsumerProfileObject };
  mode: string | null = null;
  eligible = false;
  address = '';
  address2 = '';
  city = '';
  state = '';
  postalCode = '';
  country = '';
  // phoneTypeId = 0;
  // phone = '';
  // primary = false;
  userPhone: Array<CmpUserPhoneObject> = [];
  userEmail: Array<CmpUserEmailObject> = [];
  userAddress?: CmpUserAddressObject;
  updateContactPrompt = false;
  hasOptedInForPromotionalEmail = false;
}

export class CmpRememberUserCamper {
  firstName = '';
  email = '';
}

export class CmpAddNewFamilyMemberObject {
  id = 0;
  firstName = '';
  lastName = '';
  email = '';
  emailVerifiedAt: Date | null = null;
  type = '';
  relationship: string | null = null;
  familyId = 0;
  isValid: boolean | null = null;
  mode: string | null = null;
  userConsumerProfile: { [index: string]: CmpUserConsumerProfileObject } = { '0': new CmpUserConsumerProfileObject };
  address = '';
  address2 = '';
  city = '';
  state = '';
  postalCode = '';
  country = '';
  // phoneTypeId = 0;
  // phone = '';
  // primary = false;
  userPhone: Array<CmpUserPhoneObject> = [];
  userEmail: Array<CmpUserEmailObject> = [];
}

export class CmpUserAddressObject {
  address = '';
  address2 = '';
  addressTypeId = 0;
  city = '';
  country = '';
  createdAt = '';
  deletedAt = '';
  id = 0;
  optedIn = true;
  postalCode = '';
  primary = true;
  state = '';
  updatedAt = '';
  userId = 0;
}

export class CmpAttendeesInfoObject {
  userId = 0;
  fullname = '';
  gender = '';
  dob: Date | null = null;
  age: number | null = null;
  userType = '';
  type = '';
}

export class CmpAttendeesDetailObject {
  attendeesInfo: Array<CmpAttendeesInfoObject> = [];
}

export class CmpContactObject {
  cellPhone = new CmpUserPhoneObject();
  homePhone = new CmpUserPhoneObject();
  email  = new CmpUserEmailObject();
  address = '';
  address2 = '';
  addressTypeId = 0;
  city = '';
  country = '';
  createdAt = '';
  deletedAt = '';
  id = 0;
  optedIn = true;
  postalCode = '';
  primary = true;
  state = '';
}

